import * as React from "react";
const SvgFiRrHighlighter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-highlighter_svg__a)">
      <path
        fill="#062147"
        d="m22.682 1.705-.387-.387a4.517 4.517 0 0 0-6.136-.212L4.007 11.762A6 6 0 0 0 2 16.24v4.346L.293 22.293a.999.999 0 1 0 1.414 1.414L3.414 22H7.76a6 6 0 0 0 4.483-2.013l10.654-12.15a4.515 4.515 0 0 0-.216-6.133zM4 20v-3.76c0-.253.033-.502.08-.747l4.426 4.427a4 4 0 0 1-.747.08zM21.391 6.522 10.745 18.663c-.106.12-.232.213-.35.318L5.02 13.605c.103-.116.195-.24.312-.344L17.474 2.612a2.51 2.51 0 0 1 3.407.12l.387.387c.924.924.977 2.42.123 3.403"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-highlighter_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHighlighter;
